import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { TbCompass, TbArrowLeft } from "react-icons/tb";
import AuthShell from "../v2/auth/AuthShell";

// Not found.
//
// The old version offered "Go to Home", which on this product is the login page — so
// someone already signed in was sent to a sign-in screen for the crime of following a
// stale link. This goes back instead, and the footer carries the four places a person
// actually wanted, so there is always a way out that is not the browser's back button.
//
// It also says the failure is not theirs. A 404 is usually a link the product got wrong.
const PageNotFound = () => {
  const navigate = useNavigate();

  const footer = (
    <footer className="nf-foot">
      <Link to="/login" className="nf-foot-brand">
        <img className="pnav-mark" src="/images/pipsqueak-mark.png" alt="" />
        <span>Pipsqueak</span>
      </Link>
      <div className="nf-foot-links">
        <Link to="/downloads">Download the scanner</Link>
        <Link to="/login">Sign in</Link>
        <Link to="/report">Report a bug</Link>
        <Link to="/terms">Terms of service</Link>
      </div>
    </footer>
  );

  return (
    <AuthShell brand={false} footer={footer}>
      <div className="nf">
        <div>
          <div className="nf-mark"><TbCompass size={26} /></div>
          <h1>We couldn't find that page</h1>
          <p>
            The link may be out of date, or the page may have moved. Nothing is broken on
            your end.
          </p>
          {/* history.back() when there is somewhere to go back to, and the dashboard
              otherwise — landing on a blank tab's history entry is worse than landing
              somewhere real. */}
          <button type="button" className="auth-btn"
                  onClick={() => (window.history.length > 1 ? navigate(-1) : navigate("/dashboard"))}>
            <TbArrowLeft size={16} /> Go back
          </button>
        </div>
      </div>
    </AuthShell>
  );
};

export default PageNotFound;
